import { getYearString } from "../helpers/stringHelper";

export type YearContext = {
  id: number;
  starts_at: number;
  ends_at: number;
  current: boolean;
};

export function getYearContextOptions(yearContext: YearContext[]) {
  return yearContext.map((year) => ({
    value: year.id.toString(),
    label: getYearString(year),
  }));
}
